import './Snow.scss';

export const Snow = () => {
    return (
        <>
            {Array.from({ length: 200 }, (_, i) => i).map((num) => (
                <div key={num} className="snow" />
            ))}
        </>
    );
};
